import { types } from '../reducers/appearanceGlobalAssetsReducer';

// eslint-disable-next-line import/prefer-default-export
export const createAppearanceGlobalAssets = (values) => ({
  type: types.POST,
  payload: values,
});

export const updateAppearanceGlobalAssets = (values) => ({
  type: types.PUT,
  payload: values,
});

export const removeAppearanceGlobalAssets = (index) => ({
  type: types.DELETE,
  index,
});

export const resetAppearanceGlobalAssets = () => ({
  type: types.RESET,
});

export { getDraftId } from '../reducers/appearanceGlobalAssetsReducer';
